import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useMemo } from 'react';
export const useIsPayingUser = () => {
    const { hasActiveSubscription } = useIsSubscribed();
    const { session } = useSession();
    const paymentTier = session?.user?.payment_tier;
    return useMemo(() => hasActiveSubscription && (paymentTier === 'paid' || paymentTier === 'discount'), [hasActiveSubscription, paymentTier]);
};
//# sourceMappingURL=useIsPayingUser.js.map